<!-- <div *ngIf="isLoading" class="text-center my-3">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div> -->

<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/page/dashboard"
        ><i class="icon text-info fa fa-home"></i
      ></a>
    </li>
    <li class="breadcrumb-item active">
      <a [routerLink]="['/page/project-detail', currentProject.id]"
        >{{ "Form.Project" | translate }}
      </a>
      /
      <a
        [routerLink]="['/page/project-detail', currentProject.id]"
        [fragment]="'screen'"
        >{{ "Form.SCREEN" | translate }}
      </a>
    </li>
    <li class="breadcrumb-item active" aria-current="page">
      {{ currentScreen.name }}
    </li>
  </ol>
</nav>

<div class="row">
  <div class="col-md-12">
    <div class="card main-card mb-3">
      <div class="card-body">
        <div class="row mb-3">
          <div
            class="d-flex text-start gap-2"
            style="margin: 0px 10px; padding: 8px"
          >
            <!-- <label> {{ "Form.SelectEnviornment" | translate }}</label> -->
            <select
              (change)="onfilterChange($event.target.value)"
              class="card col-1 px-3 py-2 me-3 pe-2"
            >
              <option
                style="color: #3f6ad8"
                *ngFor="let item of enviornment"
                [value]="item.value"
              >
                {{ item.label }}
              </option>
            </select>
            <!-- <label>{{ "Form.SelectVer" | translate }}</label> -->
            <select
              (change)="onVersionfilterChange($event.target.value)"
              class="card col-3 px-3 py-2 ps-2 ms-2"
            >
              <option
                style="color: #3f6ad8"
                *ngFor="let item of versionList"
                [value]="item.id"
              >
                {{ item.version }} ({{
                  item.releaseDate | date : "dd MMM yyyy"
                }})
              </option>
            </select>
          </div>
        </div>

        <ul
          ngbNav
          #nav="ngbNav"
          [destroyOnHide]="true"
          [(activeId)]="activeTabId"
          class="nav nav-pills project-tab custom-tab"
          (navChange)="onTabChange($event)"
        >
          <li [ngbNavItem]="'tooltip-tab-id'">
            <a ngbNavLink class="_tas-tabs">
              <span>Tooltip</span>
            </a>
            <ng-template ngbNavContent>
              <div class="row">&nbsp;</div>
              <div class="d-flex justify-content-end mb-2">
                <button
                  class="btn btn-primary mr-2"
                  (click)="addTooltipVisible(true)"
                >
                  Add Tooltip
                </button>

                <button
                  class="btn btn-secondary"
                  (click)="addTooltipVisible(false)"
                  *ngIf="isAddTooltip"
                >
                  Cancel
                </button>
              </div>
              <div
                class="col-md-12 col-xl-12"
                style="margin: 0px 10px; padding-bottom: 15px"
                *ngIf="isAddTooltip"
              >
                <app-dynamic-tooltip-form
                  [addTooltip]="true"
                  [project]="currentProject"
                  [screen]="currentScreen"
                  [selectedVersion]="selectedVersion"
                  [selectedEnv]="selectedEnv"
                  (onLanguageChange)="onSelectedFAQLanguageChange($event)"
                  (formSubmitted)="onFormSubmitted()"
                >
                </app-dynamic-tooltip-form>
              </div>
              <div class="row" *ngIf="!tooltips.length && !addTooltip">
                <div class="col-md-12 col-xl-12 py-3 px-3 font-size-sm">
                  {{ "Form.NoTooltip" | translate }}
                </div>
              </div>
              <div
                ngbAccordion
                #accordion="ngbAccordion"
                class="col-12 px-0 mx-auto mb-3 accordion-class accordion-class"
                *ngFor="let tooltip of tooltips"
              >
                <div class="m-2 p-2" ngbAccordionItem="{{ tooltip.label }}">
                  <div
                    ngbAccordionHeader
                    class="accordion-header"
                    style="height: 2rem !important"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between w-100"
                    >
                      <!-- Button/Title -->
                      <button
                        type="button"
                        ngbAccordionButton
                        class="accordion-button no-after-icon btn btn-link p-0 me-3 flex-grow-1 text-truncate"
                        style="border: none; background-color: transparent"
                      >
                        <h5 class="mb-0 text-truncate">
                          {{ tooltip.name }}
                        </h5>
                      </button>

                      <!-- Delete Icon -->
                      <i
                        class="fa fa-trash-o text-danger ms-2 me-2"
                        aria-hidden="true"
                        (click)="
                          deleteItem(tooltip, 'tooltip');
                          $event.stopPropagation()
                        "
                        style="cursor: pointer"
                      ></i>

                      <div ngbDropdown #dropdown="ngbDropdown" container="body">
                        <!-- Trigger -->

                        <i
                          class="fas fa-language text-primary ms-2 fs-4"
                          ngbDropdownToggle
                          role="button"
                          aria-haspopup="true"
                          [attr.aria-expanded]="dropdown.isOpen()"
                          (click)="toggleDropdown($event)"
                          style="cursor: pointer"
                        ></i>

                        <!-- Menu -->
                        <div
                          ngbDropdownMenu
                          style="
                            transform: translate(-52px, 12px);
                            box-shadow: rgba(135, 135, 135, 0.5) -14px 14px 10px;
                            position: absolute;
                            top: 0px;
                            left: 0px;
                            will-change: transform;
                            width: 200px !important;
                            padding: 0px !important;
                          "
                        >
                          <div
                            class="dropdown-menu-header-inner mt-0 pt-4 pb-4 bg-primary"
                          >
                            <div
                              class="menu-header-content text-center text-white"
                            >
                              <h6 class="menu-header-subtitle mt-0">
                                Translate
                              </h6>
                            </div>
                          </div>

                          <!-- Primary Language Group -->
                          <div
                            class="dropdown-item text-start text-muted fw-bold"
                            style="pointer-events: none; opacity: 0.6"
                          >
                            Primary Language
                          </div>
                          <div
                            class="dropdown-item text-start"
                            (click)="
                              onChangeLanguage(
                                currentProject.primaryLanguage,
                                tooltip,
                                'tooltip'
                              )
                            "
                            [ngClass]="{
                              'bg-primary text-white':
                                selectedLanguage ===
                                currentProject.primaryLanguage
                            }"
                          >
                            <span class="ms-2 ps-2">
                              {{
                                getLanguageName(currentProject.primaryLanguage)
                              }}
                            </span>
                          </div>

                          <!-- Secondary Language Group -->
                          <div
                            class="dropdown-item text-start text-muted fw-bold mt-2"
                            style="pointer-events: none; opacity: 0.6"
                          >
                            Secondary Languages
                          </div>
                          <div
                            class="dropdown-item text-start"
                            *ngFor="let psl of currentProject.supportedLanguage"
                            (click)="
                              onChangeLanguage(psl.id, tooltip, 'tooltip')
                            "
                            [ngClass]="{
                              'bg-primary text-white':
                                selectedLanguage === psl.id
                            }"
                          >
                            <span class="ms-2 ps-2">{{ psl.name }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <div
                        id="tooltip-global-config-id"
                        style="margin: 0px 10px"
                      >
                        <div class="form-validation">
                          <app-dynamic-tooltip-form
                            [tooltip]="tooltip"
                            [project]="currentProject"
                            [roles]="roles"
                            (onLanguageChange)="
                              onSelectedTooltipLanguageChange($event)
                            "
                            [screen]="currentScreen"
                            [languageChange]="languageChangeTooltip"
                            [version]="selectedVersion"
                            (formSubmitted)="onFormSubmitted()"
                          ></app-dynamic-tooltip-form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
          <li [ngbNavItem]="'workflow-tab-id'">
            <a ngbNavLink class="_tas-tabs">
              <span (click)="onTabChange($event)">Workflow</span>
            </a>
            <ng-template ngbNavContent>
              <div class="row">&nbsp;</div>
              <div
                class="d-grid gap-2 d-md-flex justify-content-md-end mb-2 pb-2"
              >
                <button
                  class="btn btn-primary me-md-2"
                  (click)="addWorkflowVisible(true)"
                >
                  Add Workflow
                </button>

                <button
                  class="btn btn-secondary"
                  (click)="addWorkflowVisible(false)"
                  *ngIf="isAddWorkflow"
                >
                  Cancel
                </button>
              </div>
              <div
                class="col-md-12 col-xl-12"
                style="margin: 0px 10px; padding-bottom: 15px"
                *ngIf="isAddWorkflow"
              >
                <app-dynamic-workflow-form
                  [addWorkflow]="true"
                  [project]="currentProject"
                  [screen]="currentScreen"
                  [selectedVersion]="selectedVersion"
                  [selectedEnv]="selectedEnv"
                  (onLanguageChange)="onSelectedFAQLanguageChange($event)"
                  (formSubmitted)="onFormSubmitted()"
                >
                </app-dynamic-workflow-form>
              </div>
              <!-- <div *ngIf="!isLoading"> -->
              <div *ngIf="workflows.length">
                <div class="position-relative row mb-3 form-group">
                  <label
                    class="col-md-4"
                    for="primary_language_id"
                    style="padding: 3px 20px; font-weight: bold"
                    >{{ "Form.DefaultWorkflow" | translate }}</label
                  >
                  <!-- <div class="row"> -->
                  <div class="col-md-4">
                    <ng-select
                      [items]="workflows"
                      [virtualScroll]="true"
                      bindLabel="name"
                      bindValue="workflowId"
                      placeholder="{{
                        'Form.SelectDefaultWorkflow' | translate
                      }}"
                      [(ngModel)]="defaultWorkflow"
                      [ngModelOptions]="{ standalone: true }"
                    >
                    </ng-select>
                  </div>

                  <button
                    class="btn btn-primary col-1"
                    style="margin-right: 10px"
                    type="submit"
                    (click)="saveDefaultWorkflow()"
                  >
                    {{ "Form.SAVE" | translate }}
                  </button>
                  <!-- </div> -->
                </div>

                <div class="row">
                  <div
                    ngbAccordion
                    #accordion="ngbAccordion"
                    class="col-12 ms-2 ps-2 me-2 pe-2 accordion-class accordion-class"
                    *ngFor="let workflow of workflows"
                  >
                    <div ngbAccordionItem="{{ workflow.name }}">
                      <div
                        ngbAccordionHeader
                        class="accordion-header"
                        style="height: 2rem !important"
                      >
                        <div
                          class="d-flex align-items-center px-2"
                          style="padding: 3px 8px !important"
                        >
                          <!-- Panel Toggle Button Text -->
                          <button
                            type="button"
                            ngbAccordionButton
                            class="accordion-button no-after-icon btn btn-link p-0 me-3 flex-grow-1 text-truncate"
                            style="
                              border: none;
                              background-color: transparent;
                              text-align: start;
                              width: 80%;
                            "
                          >
                            <h5 class="text-truncate">
                              {{ workflow.name }}
                            </h5>
                          </button>

                          <!-- Thumbs Icons -->
                          <div
                            class="d-flex align-items-end me-3"
                            style="gap: 15px"
                          >
                            <div title="Useful" class="mb-2">
                              <i
                                class="fa fa-thumbs-up"
                                style="color: #5a5a5a"
                              ></i>
                              <span class="ms-1">{{
                                faqThumbsUp[workflow.id] || 0
                              }}</span>
                            </div>
                            <div title="Needs improvement" class="mb-2">
                              <i
                                class="fa fa-thumbs-down"
                                style="color: #5a5a5a"
                              ></i>
                              <span class="ms-1">{{
                                faqThumbsDown[workflow.id] || 0
                              }}</span>
                            </div>

                            <div class="ms-auto mb-1">
                              <button
                                class="btn btn-link p-0"
                                (click)="
                                  getWorkflowHistory(
                                    workflow.workflowId,
                                    'workflow'
                                  );
                                  $event.stopPropagation()
                                "
                                ngbTooltip="{{
                                  'Form.viewhistory' | translate
                                }}"
                              >
                                <i
                                  class="fa fa-history text-primary"
                                  style="
                                    font-size: 20px !important;
                                    padding-left: 2px;
                                    margin-left: 5px;
                                  "
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </div>
                            <span
                              class="text-end mb-2"
                              (click)="
                                deleteItem(workflow, 'workflow');
                                $event.stopPropagation()
                              "
                              style="cursor: pointer"
                            >
                              <i
                                class="fa fa-trash-o text-danger"
                                aria-hidden="true"
                              ></i>
                            </span>
                            <div
                              ngbDropdown
                              #dropdown="ngbDropdown"
                              container="body"
                            >
                              <!-- Trigger -->

                              <i
                                class="fas fa-language text-primary ms-2 fs-4 mb-2"
                                ngbDropdownToggle
                                role="button"
                                aria-haspopup="true"
                                [attr.aria-expanded]="dropdown.isOpen()"
                                (click)="toggleDropdown($event)"
                                style="cursor: pointer"
                              ></i>

                              <!-- Menu -->
                              <div
                                ngbDropdownMenu
                                style="
                                  transform: translate(-52px, 12px);
                                  box-shadow: rgba(135, 135, 135, 0.5) -14px 14px
                                    10px;
                                  position: absolute;
                                  top: 0px;
                                  left: 0px;
                                  will-change: transform;
                                  width: 200px !important;
                                  padding: 0px !important;
                                "
                              >
                                <div
                                  class="dropdown-menu-header-inner mt-0 pt-4 pb-4 bg-primary"
                                >
                                  <div
                                    class="menu-header-content text-center text-white"
                                  >
                                    <h6 class="menu-header-subtitle mt-0">
                                      Translate
                                    </h6>
                                  </div>
                                </div>

                                <!-- Primary Language Group -->
                                <div
                                  class="dropdown-item text-start text-muted fw-bold"
                                  style="pointer-events: none; opacity: 0.6"
                                >
                                  Primary Language
                                </div>
                                <div
                                  class="dropdown-item text-start"
                                  (click)="
                                    onChangeLanguage(
                                      currentProject.primaryLanguage,
                                      workflow,
                                      'workflow'
                                    )
                                  "
                                  [ngClass]="{
                                    'bg-primary text-white':
                                      selectedLanguage ===
                                      currentProject.primaryLanguage
                                  }"
                                >
                                  <span class="ms-2 ps-2">
                                    {{
                                      getLanguageName(
                                        currentProject.primaryLanguage
                                      )
                                    }}
                                  </span>
                                </div>

                                <!-- Secondary Language Group -->
                                <div
                                  class="dropdown-item text-start text-muted fw-bold mt-2"
                                  style="pointer-events: none; opacity: 0.6"
                                >
                                  Secondary Languages
                                </div>
                                <div
                                  class="dropdown-item text-start"
                                  *ngFor="
                                    let psl of currentProject.supportedLanguage
                                  "
                                  (click)="
                                    onChangeLanguage(
                                      psl.id,
                                      workflow,
                                      'workflow'
                                    )
                                  "
                                  [ngClass]="{
                                    'bg-primary text-white':
                                      selectedLanguage === psl.id
                                  }"
                                >
                                  <span class="ms-2 ps-2">{{ psl.name }}</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- View History -->
                        </div>
                      </div>
                      <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                          <div
                            id="workflow-global-config-id"
                            style="margin: 10px 10px"
                          >
                            <div class="form-validation">
                              <app-dynamic-workflow-form
                                [workflow]="workflow"
                                [project]="currentProject"
                                [screen]="currentScreen"
                                [roles]="roles"
                                [version]="selectedVersion"
                                [isLanguageChanged]="isLanguageChanged"
                                [languageId]="selectedLanguage"
                                [commonObject]="commonObject"
                                (formSubmitted)="onFormSubmitted()"
                              ></app-dynamic-workflow-form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="workflows.length == 0 && !isAddWorkflow">
                <div class="col-md-12 col-xl-12 py-3 px-3 font-size-sm">
                  {{ "Form.NoWorkflow" | translate }}
                </div>
              </div>
              <!-- </div> -->
              <div *ngIf="isLoading">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </ng-template>
          </li>
          <li [ngbNavItem]="'faq-tab-id'">
            <a ngbNavLink class="_tas-tabs">
              <span (click)="onTabChange($event)">FAQ</span>
            </a>
            <ng-template ngbNavContent>
              <div class="row">&nbsp;</div>

              <div class="row">
                <div class="col-md-12 col-xl-12">
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <div *ngIf="!addFAQ">
                      <button
                        class="btn btn-primary font-size-lg"
                        style="margin-bottom: 10px"
                        (click)="addFAQVisible(true)"
                      >
                        {{ "Form.AddFAQ" | translate }}
                      </button>
                    </div>
                    <div *ngIf="addFAQ">
                      <button
                        class="btn reset-btn font-size-lg text-white"
                        style="margin-bottom: 10px"
                        (click)="addFAQVisible(false)"
                      >
                        {{ "Form.CANCEL" | translate }}
                      </button>
                    </div>
                    <div>
                      <button
                        class="btn btn-primary font-size-lg"
                        (click)="openCustomPromptWindow()"
                      >
                        {{ "Form.GenAIFaq" | translate }}
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-12 col-xl-12"
                  style="margin: 0px 10px; padding-bottom: 15px"
                  *ngIf="addFAQ"
                >
                  <div class="form-validation">
                    <app-dynamic-faq-form
                      [project]="currentProject"
                      [faq]="newFaq"
                      [screen]="currentScreen"
                      [projectVersion]="selectedVersion"
                      [selectedEnv]="selectedEnv"
                      (onLanguageChange)="onSelectedFAQLanguageChange($event)"
                      (formSubmitted)="onFormSubmitted()"
                      [selectedLanguage]="selectedLanguage"
                    ></app-dynamic-faq-form>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="!faq.length && !addFAQ">
                <div class="col-md-12 col-xl-12 py-3 px-3 font-size-sm">
                  {{ "Form.NoFAQ" | translate }}
                </div>
              </div>
              <div
                ngbAccordion
                #accordion="ngbAccordion"
                class="col-12 ms-2 ps-2 me-2 pe-2 accordion-class accordion-class"
                *ngFor="let f of faq"
                [attr.id]="f.id"
                [closeOthers]="true"
                (panelChange)="onPanelChange($event)"
              >
                <div ngbAccordionItem>
                  <div
                    ngbAccordionHeader
                    class="accordion-header"
                    style="height: 3.2rem !important"
                    (click)="setHashAndToggle(f.id, accordion)"
                  >
                    <div class="d-flex align-items-center px-2">
                      <!-- Panel Toggle Button Text -->
                      <button
                        type="button"
                        ngbAccordionButton
                        style="
                          border: none !important;
                          width: 83.5% !important;
                          height: 100% !important;
                          background-color: transparent !important;
                          cursor: pointer;
                        "
                        class="{{ f.question }} : {{
                          getSelectedFAQLanguage(f.id)
                        }}  no-after-icon"
                      >
                        <h5
                          class="mt-1"
                          style="
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            height: 2rem !important;
                          "
                        >
                          {{ f.question }} :
                          {{ getSelectedFAQLanguage(f.id) }}
                        </h5>
                      </button>
                      <div
                        class="d-flex align-items-end me-2"
                        style="gap: 10px"
                      >
                        <div title="Useful mb-2">
                          <i
                            class="fa fa-thumbs-up"
                            style="
                              color: #5a5a5a;
                              margin-right: 2px;
                              padding-right: 2px;
                            "
                          ></i
                          >{{ faqThumbsUp[f.id] }}
                        </div>
                        <div title="Needs improvement mb-2">
                          <i
                            aria-hidden="true"
                            class="fa fa-thumbs-down"
                            style="
                              color: #5a5a5a;
                              margin-right: 2px;
                              padding-right: 2px;
                            "
                            title="Needs improvement"
                          ></i
                          >{{ faqThumbsDown[f.id] }}
                        </div>

                        <div class="ms-auto">
                          <button
                            class="btn btn-link p-0"
                            (click)="
                              getFAQHistory(f.faqId, 'faq');
                              $event.stopPropagation()
                            "
                            ngbTooltip="{{ 'Form.viewhistory' | translate }}"
                          >
                            <i
                              class="fa fa-history text-primary"
                              style="
                                font-size: 20px !important;
                                padding-left: 2px;
                                margin-left: 5px;
                              "
                              aria-hidden="true"
                            ></i>
                          </button>
                          <span
                            class="text-end mb-1"
                            (click)="
                              deleteItem(f, 'faq'); $event.stopPropagation()
                            "
                            style="cursor: pointer"
                          >
                            <i
                              class="fa fa-trash-o text-danger ms-3"
                              aria-hidden="true"
                              style="cursor: pointer"
                            ></i>
                          </span>
                        </div>

                        <div
                          ngbDropdown
                          #dropdown="ngbDropdown"
                          container="body"
                        >
                          <!-- Trigger -->

                          <i
                            class="fas fa-language text-primary ms-2 fs-4 mb-1"
                            ngbDropdownToggle
                            role="button"
                            aria-haspopup="true"
                            [attr.aria-expanded]="dropdown.isOpen()"
                            (click)="toggleDropdown($event)"
                            style="cursor: pointer"
                          ></i>

                          <!-- Menu -->
                          <div
                            ngbDropdownMenu
                            style="
                              transform: translate(-52px, 12px);
                              box-shadow: rgba(135, 135, 135, 0.5) -14px 14px 10px;
                              position: absolute;
                              top: 0px;
                              left: 0px;
                              will-change: transform;
                              width: 200px !important;
                              padding: 0px !important;
                            "
                          >
                            <div
                              class="dropdown-menu-header-inner mt-0 pt-4 pb-4 bg-primary"
                            >
                              <div
                                class="menu-header-content text-center text-white"
                              >
                                <h6 class="menu-header-subtitle mt-0">
                                  Translate
                                </h6>
                              </div>
                            </div>

                            <!-- Primary Language Group -->
                            <div
                              class="dropdown-item text-start text-muted fw-bold"
                              style="pointer-events: none; opacity: 0.6"
                            >
                              Primary Language
                            </div>
                            <div
                              class="dropdown-item text-start"
                              (click)="
                                onChangeLanguage(
                                  currentProject.primaryLanguage,
                                  f,
                                  'faq'
                                )
                              "
                              [ngClass]="{
                                'bg-primary text-white':
                                  selectedLanguage ===
                                  currentProject.primaryLanguage
                              }"
                            >
                              <span class="ms-2 ps-2">
                                {{
                                  getLanguageName(
                                    currentProject.primaryLanguage
                                  )
                                }}
                              </span>
                            </div>

                            <!-- Secondary Language Group -->
                            <div
                              class="dropdown-item text-start text-muted fw-bold mt-2"
                              style="pointer-events: none; opacity: 0.6"
                            >
                              Secondary Languages
                            </div>
                            <div
                              class="dropdown-item text-start"
                              *ngFor="
                                let psl of currentProject.supportedLanguage
                              "
                              (click)="onChangeLanguage(psl.id, f.id, 'faq')"
                              [ngClass]="{
                                'bg-primary text-white':
                                  selectedLanguage === psl.id
                              }"
                            >
                              <span class="ms-2 ps-2">{{ psl.name }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <div
                        id="tooltip-global-config-id"
                        style="margin: 10px 10px"
                      >
                        <div class="form-validation">
                          <div
                            id="faq-global-config-id"
                            style="margin: 0px 10px"
                          >
                            <div class="form-validation">
                              <app-dynamic-faq-form
                                [faq]="f"
                                [project]="currentProject"
                                [projectVersion]="selectedVersion"
                                [selectedEnv]="selectedEnv"
                                [screen]="currentScreen"
                                (onLanguageChange)="
                                  onSelectedFAQLanguageChange($event)
                                "
                                (formSubmitted)="onFormSubmitted()"
                              ></app-dynamic-faq-form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="overlay-loader" *ngIf="isLoading">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </ng-template>
          </li>
          <li [ngbNavItem]="'user-guide-tab-id'">
            <a ngbNavLink class="_tas-tabs">
              <span (click)="onTabChange($event)">User Guide</span>
            </a>
            <ng-template ngbNavContent>
              <div class="row">&nbsp;</div>
              <div ngbAccordion>
                <div
                  *ngFor="let ug of userguide"
                  ngbAccordionItem
                  [collapsed]="true"
                  id="common-settings-panel-{{ ug.id }}"
                >
                  <h2 ngbAccordionHeader class="card-header">
                    <button
                      ngbAccordionButton
                      class="no-after-icon w-100"
                      style="
                        border: none !important;
                        height: 100% !important;
                        background-color: transparent !important;
                        cursor: pointer;
                      "
                    >
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <h5 class="m-0 font-weight-bold card-title">
                          {{ ug.name }}
                        </h5>
                      </div>
                      <div
                        style="
                          width: 10%;
                          display: flex;
                          column-gap: 15px;
                          justify-content: right;
                        "
                      >
                        <div>
                          <i
                            aria-hidden="true"
                            class="fa fa-thumbs-up"
                            style="color: #5a5a5a; margin: 5px 5px"
                            title="Useful"
                          ></i
                          >{{ faqThumbsUp[ug.id] }}
                        </div>
                        <div>
                          <i
                            aria-hidden="true"
                            class="fa fa-thumbs-down"
                            style="color: #5a5a5a; margin: 5px 5px"
                            title="Needs improvement"
                          ></i
                          >{{ faqThumbsDown[ug.id] }}
                        </div>
                      </div>
                      <div
                        class="btn btn-link p-0"
                        style="margin-left: auto; margin-right: 0.3rem"
                        (click)="
                          getUserGuideHistory(ug.userGuideId, 'userguide');
                          $event.stopPropagation()
                        "
                      >
                        <i
                          class="fa fa-history text-primary"
                          style="
                            font-size: 20px !important;
                            padding-left: 2px;
                            margin-left: 5px;
                          "
                          aria-hidden="true"
                        ></i>
                      </div>
                    </button>
                    <div ngbDropdown #dropdown="ngbDropdown" container="body">
                      <!-- Trigger -->

                      <i
                        class="fas fa-language text-primary ms-2 fs-4"
                        ngbDropdownToggle
                        role="button"
                        aria-haspopup="true"
                        [attr.aria-expanded]="dropdown.isOpen()"
                        (click)="toggleDropdown($event)"
                        style="cursor: pointer"
                      ></i>

                      <!-- Menu -->
                      <div
                        ngbDropdownMenu
                        style="
                          transform: translate(-52px, 12px);
                          box-shadow: rgba(135, 135, 135, 0.5) -14px 14px 10px;
                          position: absolute;
                          top: 0px;
                          left: 0px;
                          will-change: transform;
                          width: 200px !important;
                          padding: 0px !important;
                        "
                      >
                        <div
                          class="dropdown-menu-header-inner mt-0 pt-4 pb-4 bg-primary"
                        >
                          <div
                            class="menu-header-content text-center text-white"
                          >
                            <h6 class="menu-header-subtitle mt-0">Translate</h6>
                          </div>
                        </div>

                        <!-- Primary Language Group -->
                        <div
                          class="dropdown-item text-start text-muted fw-bold"
                          style="pointer-events: none; opacity: 0.6"
                        >
                          Primary Language
                        </div>
                        <div
                          class="dropdown-item text-start"
                          (click)="
                            onChangeLanguage(
                              currentProject.primaryLanguage,
                              'userguide'
                            )
                          "
                          [ngClass]="{
                            'bg-primary text-white':
                              selectedLanguage ===
                              currentProject.primaryLanguage
                          }"
                        >
                          <span class="ms-2 ps-2">
                            {{
                              getLanguageName(currentProject.primaryLanguage)
                            }}
                          </span>
                        </div>

                        <!-- Secondary Language Group -->
                        <div
                          class="dropdown-item text-start text-muted fw-bold mt-2"
                          style="pointer-events: none; opacity: 0.6"
                        >
                          Secondary Languages
                        </div>
                        <div
                          class="dropdown-item text-start"
                          *ngFor="let psl of currentProject.supportedLanguage"
                          (click)="onChangeLanguage(psl.id, '', 'userguide')"
                          [ngClass]="{
                            'bg-primary text-white': selectedLanguage === psl.id
                          }"
                        >
                          <span class="ms-2 ps-2">{{ psl.name }}</span>
                        </div>
                      </div>
                    </div>
                  </h2>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <div
                        id="userguide-global-config-id"
                        style="margin: 0px 10px"
                      >
                        <div class="form-validation">
                          <app-dynamic-userguide-form
                            [userguide]="ug"
                            [project]="currentProject"
                            [screen]="currentScreen"
                            [projectVersion]="selectedVersion"
                            [selectedEnv]="selectedEnv"
                            [roles]="roles"
                            (onLanguageChange)="
                              onSelectedUserGuideLanguageChange($event)
                            "
                            (formSubmitted)="onFormSubmitted()"
                          ></app-dynamic-userguide-form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="userguide.length == 0">
                  <div
                    class="col-md-12 col-xl-12"
                    *ngIf="userguide.length < 1 && selectedEnv == 'dev'"
                  >
                    <div *ngIf="!addUserGuide">
                      <button
                        class="btn btn-primary btn-lg font-size-lg px-3 pull-right"
                        style="margin-bottom: 10px"
                        (click)="addUserGuideVisible(true)"
                      >
                        {{ "Form.AddUserGuide" | translate }}
                      </button>
                    </div>
                    <div *ngIf="addUserGuide">
                      <button
                        class="btn reset-btn btn-lg font-size-lg text-white pull-right"
                        style="margin-bottom: 10px"
                        (click)="addUserGuideVisible(false)"
                      >
                        {{ "Form.CANCEL" | translate }}
                      </button>
                    </div>
                  </div>
                  <div
                    id="userguide-global-config-id"
                    *ngIf="addUserGuide"
                    style="margin: 0px 10px"
                  >
                    <div class="form-validation">
                      <app-dynamic-userguide-form
                        [userguide]="'new'"
                        [project]="currentProject"
                        [screen]="currentScreen"
                        [projectVersion]="selectedVersion"
                        [selectedEnv]="selectedEnv"
                        [roles]="roles"
                        (onLanguageChange)="
                          onSelectedUserGuideLanguageChange($event)
                        "
                        (formSubmitted)="onFormSubmitted()"
                      ></app-dynamic-userguide-form>
                    </div>
                  </div>
                  <div class="row" *ngIf="!userguide.length && !addUserGuide">
                    <div class="col-md-12 col-xl-12 py-3 px-3 font-size-sm">
                      {{ "Form.NoUserGuide" | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav"></div>
      </div>
    </div>
  </div>
</div>

<ng-template #addPrompt let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{ "Form.AdditionalBusiness" | translate }}</h4>
    <button
      type="button"
      class="close mt-2"
      aria-label="Close"
      (click)="d('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body lang-popup">
    <app-generate-ai-content
      [currentProject]="currentProject"
      [currentScreen]="currentScreen"
      [selectedVersion]="selectedVersion"
      [prompt]="prompt"
      [title]="title"
    >
    </app-generate-ai-content>
  </div>
</ng-template>
